import {
  NumberComparisonOperator,
  numberComparisonToLabel,
} from "@redotech/redo-model/advanced-flow/expressions/number-expression";
import { Text } from "@redotech/redo-web/text";
import { isDef } from "@redotech/util/checks";
import { memo } from "react";

export const WeightComparisonDetails = memo(function WeightComparisonDetails({
  field,
  matchType,
  matchValue,
}: {
  field: string;
  matchType?: NumberComparisonOperator;
  matchValue?: number;
}) {
  const lbs = isDef(matchValue) ? Math.floor(matchValue / 16) : undefined;
  const oz = isDef(matchValue) ? matchValue % 16 : undefined;
  const poundsLabel = isDef(lbs) ? (lbs === 1 ? " lb " : " lbs ") : undefined;
  return (
    <>
      {"If "}
      <Text fontWeight="semibold">{field}</Text>
      {" is "}
      <Text>
        {matchType ? `${numberComparisonToLabel[matchType]} ` : undefined}
      </Text>
      <Text fontWeight="semibold">{lbs ? lbs : undefined}</Text>
      <Text fontWeight="semibold">{lbs ? poundsLabel : undefined}</Text>
      <Text fontWeight="semibold">{oz ? oz : undefined}</Text>
      <Text fontWeight="semibold">{oz ? " oz " : undefined}</Text>
    </>
  );
});
